import { render, staticRenderFns } from "./LtkCollectionTile.vue?vue&type=template&id=481e5664&scoped=true"
import script from "./LtkCollectionTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkCollectionTile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkCollectionTile.vue?vue&type=style&index=0&id=481e5664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e5664",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkHeroImage: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkHeroImage.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,CContainer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CContainer.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default})
